export const CURRENCY_SYMBOLS: Record<string, string> = {
  UAH: '₴',
  USD: '$',
  EUR: '€',
}

// One price format everywhere: locale thousands separators plus the currency
// symbol — "1 250 000 $". Unknown currency codes fall back to the raw code.
export const formatPrice = (amount?: number | null, currency?: string | null): string => {
  if (amount === undefined || amount === null) return ''
  const symbol = currency ? CURRENCY_SYMBOLS[currency] || currency : ''
  return `${amount.toLocaleString('uk-UA')}${symbol ? ` ${symbol}` : ''}`
}
